import { CONFIG } from './wiki';

export const generateState = ({
  config,
  status,
  statusTarget,
  userRole,
  requestTypeId,
}) => {
  if (!config) return null;
  const { activeTab, tabs } = config;
  const _config = mergeStates({ upper: config, requestTypeId });
  const tabsState = Object.entries(tabs).reduce((s, [tab, tabConfig]) => {
    const _tabConfig = mergeStates({
      upper: _config,
      lower: tabConfig,
      requestTypeId,
    });
    const visible = !_tabConfig.tabInvisibleRoles.includes(userRole);
    return {
      ...s,
      [tab]: {
        ..._tabConfig,
        sections: generateSectionsState({
          tab,
          config: _tabConfig,
          status,
          statusTarget,
          requestTypeId,
        }),
        visible,
      },
    };
  }, {});

  let _activeTab = activeTab;
  if (typeof activeTab === 'object') {
    _activeTab = activeTab[requestTypeId];
  }

  return { ..._config, activeTab: _activeTab, tabs: tabsState };
};

const generateSectionsState = ({ tab, config, status, statusTarget }) => {
  const tabSections = CONFIG.TABS_SECTIONS[tab];
  if (!tabSections) return null;

  const onlyActiveSections = statusTarget
    ? config?.statusTargetOnlyActiveSections?.[statusTarget?.id] ?? null
    : null;

  return tabSections.reduce((s, section) => {
    const readonly =
      (onlyActiveSections && !onlyActiveSections?.includes(section)) ||
      (config.readonly &&
        !config.activeSections.includes(section) &&
        !status?.reasonTypes?.map((x) => x.name)?.includes(section)) ||
      false;

    return { ...s, [section]: { readonly } };
  }, {});
};

/**
 *
 * @param {Object} options
 * @param {Object} options.upper
 * @param {Object} options.lower
 * @param {number|string} options.requestTypeId
 */
const mergeStates = (options) => {
  const { upper, lower = {}, requestTypeId = null } = options;
  const mergeBoolean = (a, b) =>
    (a === undefined ? b : b === undefined ? a : b) || false;
  const mergeArray = (a, b) => [...(a || []), ...(b || [])];
  const mergeObjectsOfArray = (a, b) =>
    [...Object.entries(a || {}), ...Object.entries(b || {})].reduce(
      (s, [key, values]) => {
        if (s[key]) {
          s[key] = [...s[key], ...values];
          return s;
        }
        return { ...s, [key]: [...values] };
      },
      {}
    );

  return {
    activeSections: mergeArray(upper.activeSections, lower.activeSections),
    readonly: mergeBoolean(upper.readonly, lower.readonly),
    showActions: mergeArray(upper.showActions, lower.showActions),
    showStatusCard: mergeBoolean(upper.showStatusCard, lower.showStatusCard),
    showStatusTargetDropdown: mergeBoolean(
      typeof upper.showStatusTargetDropdown === 'object'
        ? upper.showStatusTargetDropdown?.[requestTypeId]
        : upper.showStatusTargetDropdown,
      typeof lower.showStatusTargetDropdown === 'object'
        ? lower.showStatusTargetDropdown?.[requestTypeId]
        : lower.showStatusTargetDropdown
    ),
    statusCardReadonly: mergeBoolean(
      upper.statusCardReadonly,
      lower.statusCardReadonly
    ),
    statusTargetValidate: mergeArray(
      upper.statusTargetValidate,
      lower.statusTargetValidate
    ),
    statusTargetOnlyActiveSections: mergeObjectsOfArray(
      upper.statusTargetOnlyActiveSections,
      lower.statusTargetOnlyActiveSections
    ),
    showTabs: upper.showTabs || [],
    tabInvisibleRoles: lower.tabInvisibleRoles || [],
  };
};

export const manageStatusesDtoToModel = ({
  statusTarget: { id, name, description },
  needReason,
  needReasonType,
  statusReasons,
}) => ({
  id,
  name,
  description,
  needReason,
  needReasonType,
  reasonTypes: statusReasons,
});
